import DOMPurify from 'dompurify';
import { classes, config } from './Constants';

export default class APIVideo {

  constructor(el) {
    this.classes = classes;
    this.config = config;
    this.$el = $(el);
    this.checkCallSetup = false;
    this.dom = {
      $swiperBanner: this.$el.find(`.${this.classes.swiperBanner}`),
    };
    this.playerKaltura = null;
  }

  getVimeoVideoId(url) {
    const regExp = /https?:\/\/(?:www\.)?(?:player\.)?vimeo(?:\.com|pro)\/(?:[^\d]+)?(\d+)(?:.*)/i;
    const match = url.match(regExp);

    return match?.[1] || null;
  }

  APIKaltura(id, idTarget, _url, indexVideo) {
    /* eslint-disable */
    try {
      this.player = window.KalturaPlayer.setup({
        targetId: idTarget,
        logLevel: 'OFF',
        plugins: true,
        playback: {
          autoplay: true,
          muted: true,
          loop: true,
          playsinline: true,
          allowMutedAutoPlay: true,
        },
        provider: {
          partnerId: window.HONDA_KALTURA_SETTINGS.partnerId,
          uiConfId: window.HONDA_KALTURA_SETTINGS.playerId
        },
      });
      this.player.loadMedia({entryId: id});
      this.player.addEventListener(this.player.Event.Core.MEDIA_LOADED, _event => {
        this.dom.$swiperBanner.find('.bg-image').addClass('opacity-0');
        this.isLoadedLazyLoadVideo = true;
        $(`#${idTarget}`).attr(this.config.dataPlayer, indexVideo);
        window.listVideo.push(this.player);
      });
    } catch (error) {
      console.log('Error: ', DOMPurify.sanitize(error));
    }
    /* eslint-enable */
  }

  APIYoutube(_el, $iframe, url, _i, indexVideo) {
    let player = '';
    $iframe.attr('id', `ytb${indexVideo}`);
    $iframe.attr(this.config.dataPlayer, indexVideo);
    const tempt = url.split('?')[0].split('/');
    window.YT.ready(() => {
      player = new window.YT.Player(`ytb${indexVideo}`, {
        height: '',
        width: '',
        videoId: tempt[tempt.length - 1],
        playerVars: {
          playlist: tempt[tempt.length - 1],
          autoplay: 1,
          loop: true,
          mute: 1,
          controls: 1,
          rel: 0,
        },
        events: {
          onReady: (event) => {
            $(player.g).removeAttr('frameborder');
            event.target.mute();
            setTimeout(() => {
              event.target.playVideo();
            }, 50);
          },
          onStateChange: (event) => {
            if (event.target.getPlayerState() === window.YT.PlayerState.PLAYING) {
              this.dom.$swiperBanner.find('.bg-image').addClass('opacity-0');
              const indexActiveVideo = this.dom.$swiperBanner.find('.swiper-slide-active .banner-bg-video').attr(this.config.dataPlayer);
              if (window.mutedVideo && $(window).innerWidth() > 1199) {
                window.listVideo[indexActiveVideo - 1].unMute();
              }
            }
          },
        },
      });
      window.listVideo.push(player);
    });
  }

  APIVimeo(el, $iframe, url, i, indexVideo) {
    let player = '';
    $iframe.attr('id', `vimeo${indexVideo}`);
    $iframe.attr(this.config.dataPlayer, indexVideo);
    const id = this.getVimeoVideoId(url);
    player = new window.Vimeo.Player(`vimeo${indexVideo}`, {
      id,
      autoplay: false,
      loop: true,
      muted: true,
      controls: false,
    });

    player.ready().then(() => {
      $(player.element).removeAttr('frameborder').removeAttr('width').removeAttr('height');
      player.play();
    });

    player.on('play', () => {
      this.dom.$swiperBanner.find('.bg-image').addClass('opacity-0');
      let index = 0;
      if ($(el).hasClass(this.classes.firstSlider)){
        index = $(el).index();
      }
      if (i === index && this.checkCallSetup === false) {
        this.setup();
        this.checkCallSetup = true;
      }
    });
    window.listVideo.push(player);
  }
}